import { AuthService } from '../services/AuthService';

export const getHeaders = (
  additionalHeaders: Record<string, string> = {}
): Record<string, string> => {
  if (AuthService.authToken !== null) {
    return {
      Authorization: `Bearer ${AuthService.authToken}`,
      ...additionalHeaders
    };
  } else {
    throw new Error('Пользователь не авторизирован');
  }
};
